<template>
  <img
    :src="LoyaltyIconSvgSilver"
    alt="loyalty-macys-silver-small.svg"
  />
</template>

<script setup>
import LoyaltyIconSvgSilver from '@core/csg/src/assets/images/mcom/compressed/loyalty-macys-silver-small.svg';
</script>
